<template>
  <div class="parking-management-bg">
    <!-- Page Title -->
    <div class="form-content">
      <h2 class="page-title ">填寫申辦</h2>
      <p class="title-description">填寫以下表單，我們將儘快與您聯係</p>

      <!-- Form Content -->

      <!-- Form Card -->
      <div class="form-card">
        <h4 class="sub-title">選擇停車場</h4>
        <div class="two-columns">
          <!-- City -->
          <div class="form-group">
            <label for="city">停車場縣市</label>
            <select id="city" v-model="formData.city" class="form-select custom-select">
              <!-- <option value="台北市">台北市</option> -->
              <!-- <option value="新北市">新北市</option> -->
              <option v-for = "county in counties" :key="county" :value="county">{{county}}</option>
            </select>
          </div>
          <!-- Parking Lot -->
          <div class="form-group">
            <label for="parking_lot">停車場</label>
            <input type="text" id="parking_lot" v-model="formData.parking_lot" placeholder="例：停車場A"
              class="form-input" />
          </div>
          <!-- Parking Type -->
          <div class="form-group">
            <label for="parking_type">停車車種選擇</label>
            <select id="parking_type" v-model="formData.parking_type" class="form-select">
              <option value="自小客車機械-限高1.8M">自小客車機械-限高1.8M</option>
              <option value="露天停車場">露天停車場</option>
            </select>
          </div>
        </div>
      </div>

      <!-- Form Card -->
      <div class="form-card">
        <h4 class="sub-title">申辦資料</h4>
        <div class="two-columns">
          <!-- Time Period -->
          <div class="form-group">
            <label for="time_period">
              <span class="required-asterisk">*</span>
              停車時段選擇</label>
            <select id="time_period" v-model="formData.time_period" class="form-select">
              <option value="月租">月租</option>
              <option value="年租">年租</option>
            </select>
          </div>
          <!-- Rental Start Date -->
          <div class="form-group">
            <label for="rental_start_date">
              <span class="required-asterisk">*</span>
              選擇起租日期</label>
            <div class="date-input-wrapper">
              <input type="date" id="rental_start_date" v-model="formData.rental_start_date" class="form-input" />
            </div>                
            <!-- <input type="date" id="rental_start_date" v-model="formData.rental_start_date" class="form-input" /> -->
          </div>
          <!-- Car Owner Name -->
          <div class="form-group">
            <label for="car_owner_name">
              <span class="required-asterisk">*</span>
              車主姓名</label>
            <input type="text" id="car_owner_name" v-model="formData.car_owner_name" placeholder="例：陳小明"
              class="form-input" />
          </div>
          <!-- License Plate Number -->
          <div class="form-group">
            <label for="lp_number">
              <span class="required-asterisk">*</span>
              車號（不需要輸入連字號-）</label>
            <input type="text" id="lp_number" v-model="formData.lp_number" placeholder="例：ABC1234"
              class="form-input" />
          </div>
          <!-- Contact Phone -->
          <div class="form-group">
            <label for="contact_phone">
              <span class="required-asterisk">*</span>

              主要聯絡電話</label>
            
            <input type="text" id="contact_phone" v-model="formData.contact_phone" placeholder="例：0987654321"
              class="form-input" />
          </div>
          <!-- Secondary Contact Phone -->
          <div class="form-group">
            <label for="secondary_contact_phone">次要聯絡電話</label>
            <input type="text" id="secondary_contact_phone" v-model="formData.secondary_contact_phone"
              placeholder="例：02-12345678" class="form-input" />
          </div>
          <!-- Email -->
          <div class="form-group">
            <label for="car_owner_email">車主電子郵件</label>
            <input type="email" id="car_owner_email" v-model="formData.car_owner_email"
              placeholder="例：example@gmail.com" class="form-input" />
          </div>
          <!-- Invoice Tax ID -->
          <div class="form-group">
            <label for="invoice_tax_id">發票統編</label>
            <input type="text" id="invoice_tax_id" v-model="formData.invoice_tax_id" placeholder="例：12345678"
              class="form-input" />
          </div>
          <!-- Invoice Title -->
          <div class="form-group">
            <label for="invoice_title">發票抬頭</label>
            <input type="text" id="invoice_title" v-model="formData.invoice_title" placeholder="例：陳小明"
              class="form-input" />
          </div>
          <!-- Billing Cycle -->
          <div class="form-group">
            <label for="billing_cycle">
              <span class="required-asterisk">*</span>
              繳費形態</label>
            <select id="billing_cycle" v-model="formData.billing_cycle" class="form-select">
              <option value="月繳">月繳</option>
              <option value="季繳">季繳</option>
              <option value="年繳">年繳</option>
            </select>
          </div>
        </div>
      </div>

      <!-- Submit Button -->
      <button type="button" class="form-submit-btn" @click="handleSubmit">送出申辦</button>
    </div>
  </div>
</template>
<script>
import { globalParams } from "@/global";
import { getCountyDistrictDict } from "@/util/util";

export default {
  data() {
    return {
      formData: {
        city: "台北市",
        parking_id: 123,
        parking_lot: "",
        parking_type: "自小客車機械-限高1.8M",
        time_period: "月租",
        rental_start_date: "2024-10-01",
        car_owner_name: "",
        lp_number: "",
        contact_phone: "",
        secondary_contact_phone: "",
        car_owner_email: "",
        invoice_tax_id: "",
        invoice_title: "",
        billing_cycle: "月繳",
        // process_status: "待處理",
        // process_comment: "無備註",
      },
      counties:[],
    };
  },
  methods: {
    handleSubmit() {
      console.log("提交表單資料", this.formData);
      this.formData.abc = 100;
      globalParams.ticket_apply_form_data = this.formData;
      console.log(JSON.stringify(globalParams))
      // alert("申請已提交");

      this.$emit("formSubmitted", this.formData);
    },
  },
  mounted() {
    const dictt = getCountyDistrictDict();
    // console.log(dictt);
    this.counties = dictt.counties;

    console.log(this.counties);
  },
};
</script>


<style scoped>
@import "@/css/form.css";

/* 主標題樣式 */
.page-title {
  margin-bottom: 0px;
}
</style>